
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { CashDro } from "@/plugins/cashdro/cashdro";

export default Vue.extend({
	data(){
		return {
			config: CashDro.getConfiguration(),
			connected: false,
			saving: false,
			path: [{
				to: "/settings/plugins", value: this.$ct("components.settings-plugin.plugins")
			}, {value: this.$ct("components.settings-plugin.cashdro")}] as IBreadCrumb[],
		};
	},
	computed: {
		defaultScreenUrl():string{
			return CashDro.getDefaultScreenUrl(this.config.host);
		}
	},
	methods: {
		async save(){
			this.saving = true;
			CashDro.saveConfiguration(this.config);
			await this.test();
			if(this.connected){
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			}else{
				this.$wf.notify(this.$ct("not-connected").toString(), "danger", 3000, "exclamation-triangle");
			}
			this.saving = false;
		},
		async test(){
			let r = await CashDro.test();
			this.connected = r.code == 1;
		}
	},
	async created(){
		await this.test();
	},
	components: {
		AppMobileFullScreenContainer
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin.AppCashDro"
	},
});
